export enum EUserBanSource {
  manual = 'manual',
  kycLink = 'kyc_link',
}

export enum ESecurityTransportKind {
  http = 'http',
  ws = 'ws',
}

export enum ERestrictionEventType {
  banActivated = 'ban_activated',
  banLifted = 'ban_lifted',
}

export enum EDevicePoolSourceKind {
  deviceVisitor = 'device_visitor',
  tlsFingerprint = 'tls_fingerprint',
  kycFingerprint = 'kyc_fingerprint',
  manualMerge = 'manual_merge',
}

export enum EDevicePoolMemberOverride {
  auto = 'auto',
  manualMerge = 'manual_merge',
  manualSplit = 'manual_split',
}
